import { useState } from 'react';
import { siteConfig } from '@/config/site';
import { useLanguage } from '@/context/LanguageContext';

export function RatesSection() {
  const { language } = useLanguage();
  const content = siteConfig.content[language].rates;
  const [activeTab, setActiveTab] = useState('inCall');

  const pricing = siteConfig.pricing;
  const currentPricing = activeTab === 'inCall' ? pricing.inCall : pricing.outCall;

  return (
    <section id="rates" className="py-20 px-4 sm:px-6 lg:px-8" data-testid="rates-section">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-[#FF4DA6] text-sm font-semibold uppercase tracking-widest mb-2">
            {content.subtitle}
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-[#F4F2FF]">
            {content.title}
          </h2>
        </div>

        {/* Tab Buttons */}
        <div className="flex justify-center gap-4 mb-8" data-testid="rates-tabs">
          <button
            onClick={() => setActiveTab('inCall')}
            className={`px-6 py-3 rounded-full font-heading font-semibold text-sm uppercase tracking-wider transition-all ${
              activeTab === 'inCall'
                ? 'bg-gradient-to-r from-[#FF4DA6] to-[#8B5CFF] text-white shadow-lg shadow-[#FF4DA6]/20'
                : 'bg-[#111022] text-[#A7A3BA] border border-white/10 hover:border-[#FF4DA6]/50'
            }`}
            data-testid="rates-tab-incall"
          >
            {content.inCallTab}
          </button>
          <button
            onClick={() => setActiveTab('outCall')}
            className={`px-6 py-3 rounded-full font-heading font-semibold text-sm uppercase tracking-wider transition-all ${
              activeTab === 'outCall'
                ? 'bg-gradient-to-r from-[#27D7FF] to-[#8B5CFF] text-white shadow-lg shadow-[#27D7FF]/20'
                : 'bg-[#111022] text-[#A7A3BA] border border-white/10 hover:border-[#27D7FF]/50'
            }`}
            data-testid="rates-tab-outcall"
          >
            {content.outCallTab}
          </button>
        </div>

        {/* Rates Card */}
        <div className="neon-card-glow" data-testid="rates-card">
          {/* Header */}
          <div className="text-center mb-6">
            <h3 className="font-heading text-xl font-semibold text-[#F4F2FF] mb-1">
              {currentPricing.label}
            </h3>
            <p className={`text-sm ${activeTab === 'inCall' ? 'text-[#27D7FF]' : 'text-[#FF4DA6]'}`}>
              {currentPricing.note}
            </p>
          </div>

          {/* Pricing Table */}
          <div className="overflow-hidden rounded-xl border border-white/10">
            <table className="w-full" data-testid="rates-table">
              <thead>
                <tr className="bg-[#0B0A12]">
                  <th className="py-4 px-6 text-left text-xs font-semibold uppercase tracking-wider text-[#A7A3BA]">
                    Service
                  </th>
                  <th className="py-4 px-6 text-center text-xs font-semibold uppercase tracking-wider text-[#A7A3BA]">
                    Duration
                  </th>
                  <th className="py-4 px-6 text-right text-xs font-semibold uppercase tracking-wider text-[#A7A3BA]">
                    Rate
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentPricing.services.map((service, idx) => (
                  <tr
                    key={service.code}
                    className={`border-t border-white/5 ${idx % 2 === 0 ? 'bg-[#111022]' : 'bg-[#0B0A12]'}`}
                    data-testid={`rate-row-${service.code.toLowerCase()}`}
                  >
                    <td className="py-4 px-6">
                      <div className="flex items-center gap-3">
                        <span className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#FF4DA6]/20 to-[#8B5CFF]/20 flex items-center justify-center text-[#FF4DA6] font-bold text-sm">
                          {service.code}
                        </span>
                        <span className="text-[#F4F2FF] font-medium">{service.name}</span>
                      </div>
                    </td>
                    <td className="py-4 px-6 text-center text-[#A7A3BA]">
                      {service.duration}
                    </td>
                    <td className="py-4 px-6 text-right">
                      <span className="text-2xl font-bold text-gradient-pink">
                        ${service.price}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Note */}
          <p className="mt-6 text-center text-sm text-[#A7A3BA]">
            {activeTab === 'inCall' ? content.noDeposit : content.depositNote}
          </p>
        </div>
      </div>
    </section>
  );
}

export default RatesSection;
